export class CArticleSearchModel{
    OrderByASC : string;
    OrderByDESC : string;
    Offset?: number;
    Fetch?: number;
    fShowInSecondPart?: boolean;
}